<template>
  <SendCredentialLink />
</template>

<script>

import SendCredentialLink from '@/components/SendCredentialLink.vue'

export default {
  name: 'SendCredential',
  components:{
    SendCredentialLink
  }
}
</script>
